import React from 'react';
import { directDeepLink, SOURCE_HOME, SOURCE_WEBVIEW } from '../../util';
import './ToolsInt.css';
import { cosmosTrackService } from '../../../../cosmosTracking/cosmosTrackService';
import { PosterIcon, VideoIcon, CouponIcon, BellIcon, ArrowRightIcon } from '../Home/Icons';


import {
	create_and_share_poster,
	create_polls,
	Tips_from_experts,
	send_notification
} from '../../../../cosmosTracking/cosmosEvents';

const TOOL_ICONS = [PosterIcon, VideoIcon, CouponIcon, BellIcon];

function ToolCardInt(props) {
	const { data } = props;

	function isMobile() {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		return /android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent);
	}

	const handleClick = (tool, index) => {
		let eventType;
		switch (index) {
			case 0:
				eventType = create_and_share_poster;
				break;
			case 1:
				eventType = create_polls;
				break;
			case 2:
				eventType = Tips_from_experts;
				break;
			case 3:
				eventType = send_notification;
				break;
			default:
				return;
		}

		cosmosTrackService(eventType);

		if (isMobile()) {
			if (index === 2 || index === 3) {
				directDeepLink(tool?.deeplink, SOURCE_HOME, SOURCE_WEBVIEW);
			} else {
				directDeepLink(tool?.deeplink, SOURCE_HOME);
			}
		} else {
			window.top.postMessage({ url: tool?.deeplink?.weblink }, '*');
		}
	};

	return (
		<>
			{data?.map((tool, index) => {
				const ToolIcon = TOOL_ICONS[index];
				return (
				<div
					key={index}
					className="tool-card-box"
					onClick={(e) =>{
						e.stopPropagation();
						handleClick(tool, index)}}>
					{ToolIcon && <ToolIcon className="tool-card-icon" />}
					<h4>{tool?.text}</h4>
					<ArrowRightIcon className="tool-card-arrow" />
				</div>
				);
			})}
		</>
	);
}

export default ToolCardInt;
